/**
 * La marca con la que el portal REAL se le muestra al cliente: el override del cliente y, campo por
 * campo, el de la agencia cuando el cliente no tiene uno propio. Es el espejo de
 * `AgencyClient.resolved_branding()` del backend, que es lo que recibe el usuario del portal al
 * loguearse (`PortalClientsPresenter`).
 *
 * Existe porque `client/:id/portal/config/` devuelve SÓLO el override —es lo que edita el formulario
 * de marca—, así que la vista previa de un cliente sin marca propia mostraba el logo y el nombre de
 * Dashbo, que su cliente no ve nunca (card E5J1Cqzu).
 *
 * `agencyData` es el `general_data` de `get-agency-data/`: su `display_name_for_clients` ya viene
 * resuelto por el backend (el nombre para clientes o, si no hay, el de la agencia).
 */
export function resolvePreviewBranding(clientBranding, agencyData) {
    const client = clientBranding || {};
    const agency = agencyData || {};
    const inherit = (own, fromAgency) => own || fromAgency || null;
    return {
        ...client,
        logo_url: inherit(client.logo_url, agency.logo_url),
        display_name_for_clients: inherit(client.display_name_for_clients,
            agency.display_name_for_clients || agency.name),
        brand_primary_color: inherit(client.brand_primary_color, agency.brand_primary_color),
        brand_secondary_color: inherit(client.brand_secondary_color, agency.brand_secondary_color),
    };
}
